import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import GUIDED_MODULES from '../data/guidedChatModules';

/* ── Icon SVGs ── */
const ICONS = {
  compass: <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"/></svg>,
  briefcase: <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg>,
  target: <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/></svg>,
  linkedin: <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/><rect x="2" y="9" width="4" height="12"/><circle cx="4" cy="4" r="2"/></svg>,
  building: <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><rect x="4" y="2" width="16" height="20" rx="2" ry="2"/><path d="M9 22v-4h6v4"/><line x1="8" y1="6" x2="8" y2="6.01"/><line x1="16" y1="6" x2="16" y2="6.01"/><line x1="12" y1="6" x2="12" y2="6.01"/><line x1="8" y1="10" x2="8" y2="10.01"/><line x1="16" y1="10" x2="16" y2="10.01"/><line x1="12" y1="10" x2="12" y2="10.01"/><line x1="8" y1="14" x2="8" y2="14.01"/><line x1="16" y1="14" x2="16" y2="14.01"/><line x1="12" y1="14" x2="12" y2="14.01"/></svg>,
  gavel: <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M14.5 2l6 6-8 8-6-6z"/><path d="M4 14l2-2"/><path d="M2 22l4-4"/><path d="M14.5 2L18 5.5"/></svg>,
  graduation: <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M22 10l-10-5L2 10l10 5 10-5z"/><path d="M6 12v5c0 2 3 3 6 3s6-1 6-3v-5"/><line x1="22" y1="10" x2="22" y2="16"/></svg>,
  cpu: <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><rect x="4" y="4" width="16" height="16" rx="2" ry="2"/><rect x="9" y="9" width="6" height="6"/><line x1="9" y1="1" x2="9" y2="4"/><line x1="15" y1="1" x2="15" y2="4"/><line x1="9" y1="20" x2="9" y2="23"/><line x1="15" y1="20" x2="15" y2="23"/><line x1="20" y1="9" x2="23" y2="9"/><line x1="20" y1="14" x2="23" y2="14"/><line x1="1" y1="9" x2="4" y2="9"/><line x1="1" y1="14" x2="4" y2="14"/></svg>,
  chat: <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>,
  assessment: <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"/></svg>,
  resume: <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>,
  interview: <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>,
};

/* ── Section definitions ── */
const SECTIONS = [
  {
    id: 'drafting',
    title: 'Draft Like a Lawyer',
    subtitle: 'Learn commercial drafting with real documents',
    badge: 'Newly Launched',
    cards: [
      { slug: 'cdp', type: 'existing', to: '/cdp', title: 'Commercial Drafting Programme', subtitle: 'Draft real agreements, get AI-assessed, and earn your certificate.', tag: 'Drafting', icon: 'gavel', color: '#b45400' },
    ],
  },
  {
    id: 'discover',
    title: 'Discover Your Path',
    subtitle: 'Figure out where you want to go',
    cards: [
      { slug: 'career-confusion', type: 'guided' },
      { slug: 'assessment', type: 'existing', to: '/assessment', title: 'Find Your Practice Area', subtitle: 'A 20-question self-assessment that maps your temperament to practice areas.', tag: 'Assessment', icon: 'assessment', color: '#0891b2' },
    ],
  },
  {
    id: 'opportunities',
    title: 'Get Opportunities',
    subtitle: 'Land that internship or job',
    cards: [
      { slug: 'internships', type: 'guided' },
      { slug: 'first-job', type: 'guided' },
      { slug: 'mock-interview', type: 'existing', to: '/mock-interview', title: 'Mock Interview with Nitin', subtitle: 'A real conversation and a real sense of where you stand.', tag: 'Interview Prep', icon: 'interview', color: '#7c3aed' },
    ],
  },
  {
    id: 'explore',
    title: 'Explore Practice Areas',
    subtitle: 'Deep dive into specific domains',
    cards: [
      { slug: 'corporate-law', type: 'guided' },
      { slug: 'litigation', type: 'guided' },
      { slug: 'higher-studies', type: 'guided' },
    ],
  },
  {
    id: 'profile',
    title: 'Build Your Profile',
    subtitle: 'Stand out from the crowd',
    cards: [
      { slug: 'resume', type: 'existing', to: '/resume', title: 'Build Resume', subtitle: 'Craft a legal resume shaped by what Indian law firms are really looking for.', tag: 'Career', icon: 'resume', color: '#059669' },
    ],
  },
  {
    id: 'general',
    title: 'Ask Nitin',
    subtitle: 'Your personal mentor, always available',
    cards: [
      { slug: 'ask-nitin', type: 'existing', to: '/ask', title: 'Ask Nitin', subtitle: 'Ask anything about your career and get straight, experience-backed guidance.', tag: 'Insights', icon: 'chat', color: '#0c2340' },
    ],
  },
];

/* ── CSS ── */
const V2_CSS = `
  @keyframes v2-rise {
    from { opacity: 0; transform: translateY(24px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  @keyframes v2-shine {
    0%   { background-position: -200% center; }
    100% { background-position: 200% center; }
  }
  @keyframes v2-drift {
    0%,100% { transform: translate(0,0); }
    50%     { transform: translate(10px,-14px); }
  }

  .v2-root {
    position: relative;
    min-height: calc(100dvh - var(--nav-h));
    background: #dbeeff;
    overflow: hidden;
    color: #0c2340;
  }
  .v2-root::before {
    content: '';
    position: absolute; inset: 0;
    background:
      radial-gradient(ellipse 80% 50% at 20% 0%, rgba(56,132,255,0.18), transparent 60%),
      radial-gradient(ellipse 60% 50% at 80% 100%, rgba(12,35,64,0.10), transparent 60%),
      linear-gradient(180deg, #e6f3ff 0%, #c9e3ff 100%);
    pointer-events: none;
  }
  .v2-root::after {
    content: '';
    position: absolute; inset: 0;
    background-image:
      linear-gradient(rgba(12,35,64,0.06) 1px, transparent 1px),
      linear-gradient(90deg, rgba(12,35,64,0.06) 1px, transparent 1px);
    background-size: 60px 60px;
    mask-image: radial-gradient(ellipse at top, black 30%, transparent 80%);
    pointer-events: none;
  }

  .v2-orb {
    position: absolute;
    width: 340px; height: 340px; border-radius: 50%;
    background: radial-gradient(circle, rgba(59,130,246,0.30), transparent 70%);
    filter: blur(50px);
    pointer-events: none;
    animation: v2-drift 14s ease-in-out infinite;
    z-index: 1;
  }
  .v2-orb.a { top: -100px; left: -80px; }
  .v2-orb.b { bottom: -140px; right: -100px; background: radial-gradient(circle, rgba(147,197,253,0.45), transparent 70%); animation-duration: 18s; }

  .v2-inner {
    position: relative; z-index: 3;
    max-width: 1080px; margin: 0 auto;
    padding: 36px 22px 60px;
  }

  .v2-hero-badge {
    display: inline-flex; align-items: center; gap: 8px;
    padding: 7px 14px;
    border: 1px solid rgba(12,35,64,0.25);
    border-radius: 999px;
    background: rgba(255,255,255,0.55);
    backdrop-filter: blur(6px);
    font-size: 10px; font-weight: 700;
    letter-spacing: 2.5px; text-transform: uppercase;
    color: #0c2340;
    animation: v2-rise 0.6s ease both;
    margin-bottom: 16px;
  }

  .v2-h1 {
    font-family: 'DM Sans', -apple-system, sans-serif;
    font-size: clamp(32px, 6vw, 56px);
    line-height: 1.08;
    font-weight: 800;
    margin: 0 0 10px;
    animation: v2-rise 0.6s ease 0.08s both;
    letter-spacing: -0.5px;
    color: #0c2340;
  }
  .v2-h1 .accent {
    background: linear-gradient(90deg, #0c2340, #1e3a8a, #3b82f6, #1e3a8a, #0c2340);
    background-size: 200% auto;
    -webkit-background-clip: text; background-clip: text;
    color: transparent;
    animation: v2-shine 5s linear infinite;
    font-style: italic;
  }

  .v2-lede {
    font-size: 14.5px; line-height: 1.7;
    color: rgba(12,35,64,0.68);
    max-width: 560px;
    margin-bottom: 32px;
    animation: v2-rise 0.6s ease 0.14s both;
  }

  .v2-section-cap {
    display: flex; align-items: center; gap: 12px;
    font-size: 10px; font-weight: 700; letter-spacing: 2.5px;
    text-transform: uppercase; color: rgba(12,35,64,0.60);
    margin-bottom: 6px; margin-top: 32px;
  }
  .v2-new-badge {
    display: inline-flex; align-items: center;
    padding: 3px 10px;
    border-radius: 999px;
    background: linear-gradient(135deg, #f59e0b, #d97706);
    color: #fff;
    font-size: 9px; font-weight: 800;
    letter-spacing: 1.2px; text-transform: uppercase;
    margin-left: 10px;
    line-height: 1;
    box-shadow: 0 2px 8px rgba(245,158,11,0.35);
    animation: v2-rise 0.6s ease 0.1s both;
  }
  .v2-section-cap::after {
    content: ''; flex: 1; height: 1px;
    background: linear-gradient(90deg, rgba(12,35,64,0.30), transparent);
  }
  .v2-section-sub {
    font-size: 13px; color: rgba(12,35,64,0.50);
    margin-bottom: 14px;
  }

  .v2-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
    margin-bottom: 8px;
  }
  @media (max-width: 900px) { .v2-grid { grid-template-columns: repeat(2, 1fr); } }
  @media (max-width: 600px) { .v2-grid { grid-template-columns: 1fr; } }

  .v2-card {
    position: relative;
    padding: 24px 22px 22px;
    border-radius: 18px;
    background: linear-gradient(160deg, #ffffff 0%, #eaf4ff 100%);
    border: 1px solid rgba(12,35,64,0.16);
    overflow: hidden;
    text-decoration: none;
    color: #0c2340;
    opacity: 0;
    animation: v2-rise 0.7s ease forwards;
    transition: transform .4s cubic-bezier(.2,.7,.2,1),
                border-color .3s ease,
                box-shadow .35s ease;
    cursor: pointer;
    min-height: 160px;
    display: flex; flex-direction: column;
  }
  .v2-card::after {
    content: '';
    position: absolute; top: 0; left: -60%;
    width: 40%; height: 100%;
    background: linear-gradient(120deg, transparent, rgba(59,130,246,0.12), transparent);
    transform: skewX(-20deg);
    transition: left .7s ease;
    pointer-events: none;
  }
  .v2-card:hover {
    transform: translateY(-4px);
    border-color: rgba(30,58,138,0.45);
    box-shadow:
      0 20px 50px -16px rgba(12,35,64,0.22),
      0 0 0 1px rgba(30,58,138,0.08) inset;
  }
  .v2-card:hover::after { left: 140%; }

  .v2-card .top {
    display: flex; align-items: center; justify-content: space-between;
    gap: 12px; margin-bottom: 10px;
  }
  .v2-card .top h3 { flex: 1; margin-bottom: 0; }
  .v2-card h3 {
    font-family: 'DM Sans', -apple-system, sans-serif;
    font-size: 20px; font-weight: 700;
    margin-bottom: 6px; color: #0c2340;
  }
  .v2-card p.desc {
    font-size: 13px; line-height: 1.6;
    color: rgba(12,35,64,0.60);
    flex: 1;
  }
  .v2-card .foot {
    display: flex; align-items: center; justify-content: space-between;
    margin-top: 14px; padding-top: 12px;
    border-top: 1px solid rgba(12,35,64,0.10);
  }
  .v2-card .tag {
    font-size: 10px; font-weight: 700; letter-spacing: 1.5px;
    text-transform: uppercase; color: rgba(12,35,64,0.50);
  }
  .v2-card .open-link {
    display: inline-flex; align-items: center; gap: 5px;
    font-size: 12px; font-weight: 700;
    color: #0c2340; letter-spacing: 0.5px;
    transition: transform .3s ease;
  }
  .v2-card:hover .open-link { transform: translateX(3px); color: #1e3a8a; }

  .v2-v1-link {
    display: inline-flex; align-items: center; gap: 8px;
    margin-top: 32px; padding: 10px 20px;
    border-radius: 10px;
    background: rgba(255,255,255,0.6);
    border: 1px solid rgba(12,35,64,0.18);
    color: #0c2340; font-size: 13px; font-weight: 600;
    text-decoration: none;
    backdrop-filter: blur(4px);
    transition: background 0.2s, border-color 0.2s;
  }
  .v2-v1-link:hover {
    background: rgba(255,255,255,0.9);
    border-color: rgba(12,35,64,0.35);
  }
`;

const ARROW = (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12 5 19 12 12 19" />
  </svg>
);

export default function DashboardV2() {
  const { user } = useAuth();
  const firstName = user?.name ? user.name.split(' ')[0] : '';
  const isAdmin = ['admin', 'superadmin'].includes(user?.role);

  useEffect(() => {
    if (typeof document === 'undefined') return;
    if (!document.getElementById('v2-style')) {
      const tag = document.createElement('style');
      tag.id = 'v2-style';
      tag.textContent = V2_CSS;
      document.head.appendChild(tag);
    }
  }, []);

  // 3D tilt
  const handleTilt = (e) => {
    const el = e.currentTarget;
    const r = el.getBoundingClientRect();
    const x = (e.clientX - r.left) / r.width - 0.5;
    const y = (e.clientY - r.top) / r.height - 0.5;
    el.style.transform = `translateY(-4px) rotateX(${-y * 5}deg) rotateY(${x * 7}deg)`;
  };
  const resetTilt = (e) => { e.currentTarget.style.transform = ''; };

  let cardIndex = 0;

  const renderCard = (card) => {
    const delay = `${0.2 + cardIndex * 0.06}s`;
    cardIndex++;

    if (card.type === 'guided') {
      const mod = GUIDED_MODULES[card.slug];
      if (!mod) return null;
      return (
        <Link
          key={card.slug}
          to={`/chat/${card.slug}`}
          className="v2-card"
          style={{ animationDelay: delay }}
          onMouseMove={handleTilt}
          onMouseLeave={resetTilt}
        >
          <div className="top">
            <h3>{mod.title}</h3>
            <div style={{ ...iconWrapStyle, borderColor: `${mod.color}35`, background: `${mod.color}12` }}>
              <span style={{ color: mod.color }}>{ICONS[mod.icon]}</span>
            </div>
          </div>
          <p className="desc">{mod.subtitle}</p>
          <div className="foot">
            <span className="tag">{mod.tag}</span>
            <span className="open-link">Start {ARROW}</span>
          </div>
        </Link>
      );
    }

    // Existing feature card
    return (
      <Link
        key={card.slug}
        to={card.to}
        className="v2-card"
        style={{ animationDelay: delay }}
        onMouseMove={handleTilt}
        onMouseLeave={resetTilt}
      >
        <div className="top">
          <h3>{card.title}</h3>
          <div style={{ ...iconWrapStyle, borderColor: `${card.color}35`, background: `${card.color}12` }}>
            <span style={{ color: card.color }}>{ICONS[card.icon]}</span>
          </div>
        </div>
        <p className="desc">{card.subtitle}</p>
        <div className="foot">
          <span className="tag">{card.tag}</span>
          <span className="open-link">Enter {ARROW}</span>
        </div>
      </Link>
    );
  };

  return (
    <div className="v2-root">
      <div className="v2-orb a" />
      <div className="v2-orb b" />

      <div className="v2-inner">
        {/* Hero */}
        <div className="v2-hero-badge">
          <span style={{ width: '20px', height: '1px', background: 'linear-gradient(90deg, #0c2340, transparent)' }} />
          Personal Mentor for Law Students
        </div>
        <h1 className="v2-h1">
          {firstName ? `${firstName}, ` : ''}Your <span className="accent">Career</span> Starts Here
        </h1>
        <p className="v2-lede">
          Choose what you need help with. Each path asks you a few questions first, so the advice you get is tailored to exactly where you are.
        </p>

        {/* Sections */}
        {SECTIONS.map((section) => (
          <div key={section.id}>
            <p className="v2-section-cap">{section.title}{section.badge && <span className="v2-new-badge">{section.badge}</span>}</p>
            <p className="v2-section-sub">{section.subtitle}</p>
            <div className="v2-grid">
              {section.cards.map(renderCard)}
            </div>
          </div>
        ))}


        {/* Link back to V1 — admin only */}
        {isAdmin && (
          <Link to="/classic" className="v2-v1-link">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="15 18 9 12 15 6"/>
            </svg>
            Classic Dashboard
          </Link>
        )}
      </div>
    </div>
  );
}

const iconWrapStyle = {
  width: '52px', height: '52px',
  borderRadius: '14px',
  border: '1px solid',
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  flexShrink: 0,
};
